// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Control_Bind from "../Control.Bind/index.js";
import * as Data_Unit from "../Data.Unit/index.js";
import * as Effect from "../Effect/index.js";
import * as Effect_Class from "../Effect.Class/index.js";
import * as Effect_Uncurried from "../Effect.Uncurried/index.js";
import * as Specular_Internal_Profiling from "../Specular.Internal.Profiling/index.js";
var discard = /* #__PURE__ */ Control_Bind.discard(Control_Bind.discardUnit);
var pure = /* #__PURE__ */ Control_Applicative.pure(Effect.applicativeEffect);
var measure = function (dictMonadEffect) {
    var Monad0 = dictMonadEffect.Monad0();
    var Bind1 = Monad0.Bind1();
    var bind = Control_Bind.bind(Bind1);
    var liftEffect = Effect_Class.liftEffect(dictMonadEffect);
    var discard1 = discard(Bind1);
    var pure1 = Control_Applicative.pure(Monad0.Applicative0());
    if (Specular_Internal_Profiling.enabled) {
        return function (name) {
            return function (action) {
                return bind(liftEffect(function () {
                    return Specular_Internal_Profiling.begin(name);
                }))(function (mark) {
                    return bind(action)(function (result) {
                        return discard1(liftEffect(function () {
                            return Specular_Internal_Profiling.end(mark);
                        }))(function () {
                            return pure1(result);
                        });
                    });
                });
            };
        };
    };
    return function (v) {
        return function (action) {
            return action;
        };
    };
};
var end = /* #__PURE__ */ (function () {
    if (Specular_Internal_Profiling.enabled) {
        return Effect_Uncurried.runEffectFn1(Specular_Internal_Profiling.end);
    };
    return function (v) {
        return pure(Data_Unit.unit);
    };
})();
var begin = /* #__PURE__ */ (function () {
    if (Specular_Internal_Profiling.enabled) {
        return Effect_Uncurried.runEffectFn1(Specular_Internal_Profiling.begin);
    };
    return function (v) {
        return pure(Specular_Internal_Profiling.none);
    };
})();
export {
    begin,
    end,
    measure
};
export {
    enabled
} from "../Specular.Internal.Profiling/index.js";
